import React from 'react';

const SuccessPage = () => {
  // Função para redirecionar para a página inicial do site principal
  const goToHome = () => {
    window.location.href = 'https://alleanzabrasilcorretora.com.br/';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6 text-center">
      <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded-xl shadow-lg animate-fade-in">
        
        {/* Ícone de Sucesso */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-5">
          <svg className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Mensagem Principal */}
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
          Solicitação enviada com sucesso!
        </h1>

        {/* Mensagem de Suporte */}
        <p className="text-gray-600 mb-8">
          Agradecemos o seu contato. Em breve, um de nossos consultores especializados entrará em contato com você.
        </p>

        {/* Botão para Voltar */}
        <button
          onClick={goToHome}
          className="w-full h-12 px-6 bg-[#2A4DD0] text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
        >
          Voltar para a Página Inicial
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;